"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.solPaymentGuardManifest = void 0;
const generated_1 = require("../generated");
const guards_1 = require("../guards");
/**
 * The solPayment guard is used to charge an
 * amount in SOL for the minted NFT.
 */
exports.solPaymentGuardManifest = {
    name: 'solPayment',
    serializer: generated_1.getSolPaymentSerializer,
    mintParser: (context, mintContext, args) => ({
        data: new Uint8Array(),
        remainingAccounts: [{ publicKey: args.destination, isWritable: true }],
    }),
    routeParser: guards_1.noopParser,
};
//# sourceMappingURL=solPayment.js.map